import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Browser.es.js";
const r = o.forwardRef((e, s) => /* @__PURE__ */ o.createElement(t, { ref: s, ...e, weights: a }));
r.displayName = "BrowserIcon";
const n = r;
export {
  n as Browser,
  r as BrowserIcon
};
